const fonts = {
  barlowCondensed: 'Barlow Condensed, sans-serif',
  barlow: 'Barlow, sans-serif',
  pko: 'PKO, sans-serif',
};

export default fonts;
